module.exports = __webpack_public_path__ + "img/mynumber-card.47b85928.png";